import { createApp } from 'vue';
import { VueSignalR } from '@dreamonkey/vue-signalr';
import { HubConnectionBuilder } from '@microsoft/signalr';
import config from '@/config';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import { defineRule } from 'vee-validate';
import { confirmed, email, ext, is, max, min, regex, required, size } from '@vee-validate/rules';

defineRule('confirmed', confirmed);
defineRule('email', email);
defineRule('ext', ext);
defineRule('is', is);
defineRule('max', max);
defineRule('min', min);
defineRule('regex', regex);
defineRule('required', required);
defineRule('size', size);

router.beforeEach((to, from, next) => {
  store.dispatch('updateCurrentModal', {
    component: null,
    params: null,
  });
  next();
});

const app = createApp(App)
  .use(router)
  .use(store)
  .use(i18n)
  .use(VueSignalR, { connection: new HubConnectionBuilder().withUrl(config.SOCKET_URL).withAutomaticReconnect().build() })
  .component('VueDatePicker', VueDatePicker);

router.isReady().then(() => {
  app.mount('#app');
});
